import { useEffect, useState } from "react";
import { BuyButton } from "@/components/ProductCard";
import { X } from "@phosphor-icons/react";

export function StickyTopPick({ product, label = "Today's Top Pick", showAfter = 500, testid = "sticky-top-pick" }) {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > showAfter);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [showAfter]);

  if (!product || dismissed) return null;
  return (
    <div
      data-testid={testid}
      className={`hh-mobile-bar md:hidden fixed bottom-0 inset-x-0 z-30 bg-white/95 backdrop-blur-lg border-t border-[#E5E0D8] shadow-[0_-8px_24px_rgba(44,43,41,0.12)] px-3 pt-2.5 pb-[calc(0.625rem+env(safe-area-inset-bottom))] flex items-center gap-3 transition-transform duration-300 ${visible ? "translate-y-0" : "translate-y-full"}`}
    >
      <div className="relative shrink-0">
        <img src={product.image_url} alt={product.title} className="w-12 h-12 rounded-lg object-cover" />
        <button data-testid={`${testid}-close`} aria-label="Dismiss" onClick={() => setDismissed(true)} className="absolute -top-2 -left-2 w-6 h-6 rounded-full bg-[#2C2B29] text-white flex items-center justify-center">
          <X size={11} weight="bold" />
        </button>
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-[9px] uppercase tracking-[0.12em] text-[#D17A58] font-bold whitespace-nowrap">{label}</p>
        <p data-testid={`${testid}-title`} className="text-[13px] font-semibold text-[#2C2B29] truncate leading-tight">{product.title}</p>
        <p className="text-xs font-semibold text-[#5C5A56]">{product.price}</p>
      </div>
      <BuyButton product={product} testid={`${testid}-buy`} className="!px-3 !py-2.5 text-xs shrink-0" />
    </div>
  );
}
